import React__default, { useRef, useEffect } from 'react';
import { IlIcon } from '../IlIcon/index.js';
import { IlSkeletonText } from '../IlSkeletons/IlSkeletonText/index.js';
import 'carbon-components-react';

/* eslint-disable */
var IlDataTableV3CellRenderer = function IlDataTableV3CellRenderer(props) {
  var dragRef = useRef(null);
  useEffect(function () {
    if (props.showRowDragger) {
      props.registerRowDragger(dragRef.current);
    }
  }, []);
  if (props.loading) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: 'IlDataTableV3-Skeleton'
    }, /*#__PURE__*/React__default.createElement(IlSkeletonText, {
      width: '100%'
    }));
  }
  var rowDragger = null;
  if (props.showRowDragger) {
    if (props.rowDraggerRenderer) {
      rowDragger = props.rowDraggerRenderer(dragRef);
    } else {
      rowDragger = /*#__PURE__*/React__default.createElement("div", {
        ref: dragRef,
        className: 'IlDataTableV3-RowDragger'
      }, /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "gs-reorderrow",
        size: 16
      }));
    }
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: 'IlDataTableV3ContextMenuWrapper',
    onContextMenu: function onContextMenu(ev) {
      if (ev.target.tagName.toUpperCase() === 'DIV') {
        ev.preventDefault();
        setContextMenuX(ev.clientX);
        setContextMenuY(ev.clientY);
        setContextMenuVisible(true);
        setContextMenuItems(column.contextMenuItems || props.contextMenuItems);
        setContextMenuData(props);
      }
    }
  }, rowDragger, /*#__PURE__*/React__default.createElement("div", null, props.prevCellRenderer ? props.prevCellRenderer(props) : props.value));
};

export { IlDataTableV3CellRenderer };
